export default __webpack_public_path__ + "static/media/tabs.20670c6c.png";